<template>
  <div class="detail-container" v-if="previewList.length>0">
    <div class="detail-content">
      <div class="detail-di">
        <img src="../images/di.png" alt="" />
        <div class="detail-title" >{{previewList[num][0].tagName}}</div>
      </div>
    <!-- 视频部分 -->
    <div class="video-container" >
      <span class="video-name">视频</span>
      <YPlayer
    v-for=" (item,index) in previewList[num]" :key="index"
      ref="mVideo"
      :video-url="item.videoUrl"
      width= "100%"
      height= "400px"
      :index="index"
      @play="play(item,index)"
      @ended="ended()"
      @pause="pause()"
      style="margin-bottom:20px"
      ></YPlayer>
    </div>
    <!-- 讲义部分 -->
    <div class="handout-container" v-if="previewList[num][0].handout">
      <span class="handout-name">讲义</span>
      <div class="handout-content"
        v-katexUbb="htmlDeCode(previewList[num][0].handout)"
        @click="getImgData(previewList[num][0].handout)"
      />
    </div>
    </div>
    <!-- 切换上下知识点视频 -->
    <div class="switch-video">
      <span @click="previous" :class="['knowledge',{'disable':this.num===0}]">上个知识点</span>
      <span  @click="next"
      :class="['knowledge',{'disable':this.num===this.previewList.length-1}]">下个知识点</span>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { htmlDecodeByRegExp } from '@/utils/index';
import api from '@/pages/uc-web/api/api';
import YPlayer from './Ylayer.vue';

export default {
  name: 'VideoDetail',
  components: {
    YPlayer,
  },
  props: {
    previewList: {
      type: Array,
      default: () => [],
    },
    activeNum: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      dp: null,
      num: 0,
      duration: '',
      isPause:true,
      eventBegin:0,
      time: 0,
      timer: null,
      item:{},
      index:0
    };
  },
  methods: {
    ready(item) {
      console.log('>>>>', item);
    },
    // 上个视频
    previous() {
      if (this.num > 0) {
      const videoDuration = document.getElementsByClassName('dplayer-video')[this.index].duration
      if(videoDuration){
        this.VideoProgress()
      }
        this.num -= 1;
        this.$emit('changeNum', this.num);
      }
    },
    // 下个视频
    next() {
      if (this.num < this.previewList.length - 1) {
        const videoDuration = document.getElementsByClassName('dplayer-video')[this.index].duration
      if(videoDuration){
        this.VideoProgress()
      }
        this.num += 1;
        this.$emit('changeNum', this.num);
      }
    },
    getImgData(str) {
      const reg = /src="([^"]+(.jpg|.gif|.jpeg|.png))"/ig;
      const result = reg.exec(str);
      if (result) {
        this.imgDatas.push(result[1]);
      }
    },
    htmlDeCode(str) {
      if (str) {
        const res = htmlDecodeByRegExp(str);
        return res;
      } if (str == '' && (typeof str === 'string')) {
        return '';
      } if (str == 0 && (typeof str === 'number')) {
        return 0;
      }
    },
    // 上传视频进度方法
    VideoProgress(){
       // 判断是不是第一次暂停
       if(this.index===0){
          const videoDuration = document.getElementsByClassName('dplayer-video')[this.index].duration
        let eventEnd = document.getElementsByClassName('dplayer-video')[this.index].currentTime
       const eventBegin = this.item.eventEnd
       clearInterval(this.timer)
       this.timer=0;
       const duration = this.time;
       this.time=0;
       console.log({duration})
      if(this.isPause){
        this.VideoProgressUpdate(Math.floor(videoDuration),Math.floor(eventEnd),Math.abs(Math.floor(duration)),Math.floor(eventBegin))
        this.eventBegin =  document.getElementsByClassName('dplayer-video')[this.index].currentTime
        this.isPause = false
      }else if(this.isPause===false&&eventEnd !==this.eventBegin&&duration>0){
        const eventEnd = document.getElementsByClassName('dplayer-video')[this.index].currentTime
        this.VideoProgressUpdate(Math.floor(videoDuration),Math.floor(eventEnd),Math.abs(Math.floor(duration)),Math.floor(this.eventBegin))
        this.eventBegin = eventEnd
      }
       }

    },
    initVideo() {
      if (this.$refs.mVideo) {
        this.$refs.mVideo.yplayer.init();
      }
    },
    ended() {
      console.log('结束了视频');
      this.eventBegin = 0
    },
    pause() {
      const videoDuration = document.getElementsByClassName('dplayer-video')[this.index].duration
      // this.current = document.getElementsByClassName('dplayer-video')[0].currentTime
      if(videoDuration){
        console.log('掉了pause');
        this.VideoProgress()
      }
    },
    play(item,index) {
      console.log('play')
      this.item = item
      this.index = index
      // console.log(this.item)
        // document.getElementsByClassName('dplayer-video')[0].currentTime = this.current;
        // const currentTime = document.getElementsByClassName('dplayer-video')[0].currentTime
        // if(currentTime===0){
        //   this.$refs.mVideo.seek(this.previewList[this.num].eventEnd)
        // }
        if(this.index===0){
           if (!this.timer) {
          this.timer = setInterval(() => {
            console.log('interval')
            this.time += 1;
          }, 1000);
        }

        if (this.isPause) {
          const videoDuration = document.getElementsByClassName('dplayer-video')[this.index].duration
        document.getElementsByClassName('dplayer-video')[this.index].currentTime = this.item.eventEnd;

       const eventBegin = this.item.eventEnd || 0
       const eventEnd = this.item.eventEnd || 0
       const duration = 0;
      this.VideoProgressUpdate(Math.floor(videoDuration),Math.floor(eventEnd),Math.floor(duration),Math.floor(eventBegin))
      }
        }

    },
    error() {
      console.log('errorrrrrrrrrrrrrr');
    },
    // 上传视频进度
    async VideoProgressUpdate(videoDuration ,eventEnd,duration,eventBegin) {;
      const params = {
        videoId: this.item.videoId,
        tagCode: this.item.tagCode,
        videoUrl: this.item.videoUrl,
        videoType: this.item.videoType,
        videoDuration: Math.floor(videoDuration),
        eventBegin: Math.floor(eventBegin),
        eventEnd: Math.floor(eventEnd),
        duration: Math.abs(Math.floor(duration)),
        schoolNatureId:localStorage.getItem('school_nature_id')||''
      };
      const res = await api.videoProgressUpdate(params);
      // console.log(params);
      console.log(res);
    },
  },
  watch: {
    activeNum() {
      this.num = this.activeNum;
    },
    num(){
      this.eventBegin = 0
      this.isPause = true
      this.index =  0
      document.querySelector('.detail-content').scrollTop = 0
    },
    item(){
      this.isPause = true
    }
  },
  // 一定要在mounted中创建
  mounted() {
      if (!navigator.userAgent.includes('DingTalk')) {
         window.addEventListener('beforeunload', (event) => {
      event.preventDefault();
      // event.returnValue = '';
      this.VideoProgress()
    });
   }
    // console.log('看看mounted', document.getElementsByClassName('dplayer-video'));
  },
  beforeDestroy() {
    if(this.timer){
       clearInterval(this.timer)
    }
  },
  computed:{
    // current(){
    //   return this.previewList[this.num].eventEnd
    // }
  },
};
</script>

<style lang="scss" scoped>
.detail-container{
  padding: 26px 24px 0 24px;
  font-family: PingFangSC-Regular, PingFang SC;
    position: relative;

  .detail-content{
    height: 550px;
    overflow-y: auto;
    .detail-di{
    position: relative;
      margin-bottom: 20px;
    }
    .detail-title {
      position: absolute;
      font-size: 17px;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.8);
      top: 2px;
      left: 11px;
    }
  }

  .video-container{
    .video-name{
      font-size: 14px;
      font-weight: 400;
      color: #606266;
      margin-bottom: 12px;
      display: block;
    }
    .video-play{
      margin-top: 15px;
      margin-bottom: 12px;
      width: 664px;
      height: 400px;
    }
  }
  .handout-container{
    .handout-name{
      font-size: 14px;
      font-weight: 400;
      color: #606266;
      margin-bottom: 12px;
      margin-top: 12px ;
      display: block;
    }
    .handout-content{
      margin-top: 15px;
      margin-bottom: 60px;
      width: 664px;
      // background-color: #ccc;
      position: relative;
      img{
        width: 100%;
      }
    }
  }
  .switch-video{
    width: 664px;
    height: 56px;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    // position: absolute;
      // bottom: 0;
    .knowledge{
      font-size: 15px;
      color: #1989FA;
      cursor: pointer;
    }
    .disable{
      color:rgba(0,137,255,0.4)
    }
  }
}
@media screen and (max-width: 1200px) {
  .detail-container .handout-container .handout-content {
    width: 100%;
  }
  .detail-container .switch-video {
    width: 100%;
    left: 0;
  }
}
</style>
